import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="w-full border-t border-gray-100 py-2 mt-auto">
            <div className="max-w-[1200px] mx-auto px-6">
                <div className="text-center text-xs text-gray-500">
                    © 2025 jakubgil.ai — Technology demo recreated independently. No proprietary code or assets used.
                </div>
            </div>
        </footer>
    );
};

export default Footer; 